import styled from "styled-components/macro";

import { Title, sidePadding } from "Payments/PaymentPage//Shared/style.js";

export default function PaymentCancelled({
  noun,
  fundColor,
  canceledPreviously,
}) {
  const reloadWindow = () => {
    const url = window.location.origin + window.location.pathname;
    window.location.href = url;
  };

  const getTitle = () => {
    if (canceledPreviously) {
      return `This ${noun} has already been cancelled.`;
    } else {
      return `Your ${noun} has been cancelled.`;
    }
  };

  return (
    <Wrapper>
      <Title>{getTitle()}</Title>
      <Text>
        You can safely close this window, or{" "}
        <Link onClick={reloadWindow} color={fundColor}>
          make a new {noun}
        </Link>
        .
      </Text>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  box-sizing: border-box;
  padding: 28px;
  ${sidePadding}
`;

const Text = styled.div`
  padding: 28px 0;
  font-size: 18px;
  font-weight: 400;
`;

const Link = styled.span`
  cursor: pointer;
  color: ${({ color }) => color};
  text-decoration: underline;
`;
